module.exports = __webpack_public_path__ + "static/media/s11.118e08eb.ogg";